import {
  BankOutlined,
  CalendarOutlined,
  NotificationOutlined,
  UserOutlined,
  UsergroupDeleteOutlined,
} from "@ant-design/icons";
import { Dropdown, MenuProps, Space } from "antd";
import React from "react";

interface Props {
  user?: any;
}
const PublicMenu = (Props: Props) => {
  const PublicMenu: MenuProps["items"] = [
    {
      label: "Empresas",
      key: "1",
      icon: <BankOutlined />,
      onClick: () => {
        window.location.href = "/entities";
      },
    },
    {
      label: "Capacidades",
      key: "2",
      icon: <UsergroupDeleteOutlined />,
      onClick: () => {
        window.location.href = "/capacities";
      },
    },
    {
      label: "Eventos",
      key: "3",
      icon: <CalendarOutlined />,
      onClick: () => {
        window.location.href = "/events-listing";
      },
    },
    {
      label: "Convocatorias",
      key: "4",
      icon: <NotificationOutlined />,
      onClick: () => {
        window.location.href = "/announcements-listing";
      },
    },

    {
      label: "Entrar",
      key: "3",
      icon: <UserOutlined />,
      onClick: () => {
        window.location.href = "/login";
      },
    },
  ];

  const menuProps = {
    items: PublicMenu,
    onClick: () => {},
  };

  const Menu: React.FC = () => {
    return (
      <a href="#" onClick={(e) => e.preventDefault()}>
        <svg viewBox="0 0 100 80" width="25" height="25">
          <rect fill="#ff974d" width="100" height="20"></rect>
          <rect fill="#ff974d" y="30" width="100" height="20"></rect>
          <rect fill="#ff974d" y="60" width="100" height="20"></rect>
        </svg>
      </a>
    );
  };

  return (
    <Dropdown className="movil-menu" menu={menuProps} trigger={["click"]}>
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          <Menu />
        </Space>
      </a>
    </Dropdown>
  );
};

export default PublicMenu;
